/* @sravni/react-design-system version 0.2.50 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { SPACE_SIZES } from '../../../constants/spaces.js';
import '../../Space/index.js';
import modules_6b210db9 from '../styles/Menu.module.less.js';
import Space from '../../Space/src/Space.js';

/**
 * @description Menu Item Group component.
 *
 * @component
 * @example
 * ```jsx
 * <Menu.ItemGroup title="hint">
 *   <Menu.Item>1 год</Menu.Item>
 * </Menu.Item>
 * ```
 */
var MenuItemGroup = React.forwardRef(function (props, ref) {
    var label = props.label, className = props.className, children = props.children, restProps = __rest(props, ["label", "className", "children"]);
    var cx = useStyles(modules_6b210db9);
    var classNames = cx(className, 'itemGroup');
    return (React.createElement(Space, __assign({ ref: ref, direction: "vertical", className: classNames }, restProps),
        React.createElement(Space, { align: "center", size: SPACE_SIZES.S4, className: cx('itemBase', 'label') }, label),
        children));
});
MenuItemGroup.defaultProps = {};

export default MenuItemGroup;
//# sourceMappingURL=MenuItemGroup.js.map
